export enum UserStatusType {
  AUTHED = 'auth',
  VISITOR = 'visitor',
}

export enum WalletType {
  METAMASK = 'metamask',
  WALLETCONNECT = 'walletconnect',
}

export enum NetworkType {
  ROPSTEN = 'ropsten',
  MUMBAI = 'mumbai',
  POLYGON = 'polygon',
  MAINNET = 'ethereum',
  UNSUPPORTED = 'unsupported',
}

export interface IUser {
  accountName: string;
  status: UserStatusType;
  walletType: WalletType | '';
  networkId?: number | 0; 
}
